import { lazy } from "react";

export const WhitelistPage = lazy(() =>
  import("./WhitelistPage.jsx").then((module) => ({
    default: module.default,
  }))
);
